import type { IImporter } from '@feathr/blackbox';
import type { TProgressMode } from '@feathr/extender/components/ProgressCell';
import { toInProgressMode } from '@feathr/extender/components/ProgressCell';

export const MAX_RUNNING_IMPORT_PERCENT = 99;

interface IImportProgressInputs {
  state: IImporter['state'];
  progress: IImporter['progress'];
}

/** Failed and draft imports show N/A; a pending one shows its percent, capped at 99. */
export function getImportProgressMode({ state, progress }: IImportProgressInputs): TProgressMode {
  if (state === 'failed' || state === 'draft') {
    return { kind: 'notApplicable' };
  }

  if (state === 'complete') {
    return { kind: 'complete' };
  }

  return toInProgressMode(progress, MAX_RUNNING_IMPORT_PERCENT);
}
